import { createLazyFileRoute } from "@tanstack/react-router";

import { EditInstrumentPage } from "@/features/admin/routes/InstrumentEdit";

export const Route = createLazyFileRoute("/_auth/admin/instruments/$id/edit")({
  component: () => {
    const params = Route.useParams();
    return <EditInstrumentPage {...params} />;
  },
});
